<template>
  <div style="padding: 5%; max-width: 1000px">
    <h1>Reviews</h1>
    <v-btn
      @click="
        reviews.push({
          review: '',
          name: '',
          rating: 5,
          timestamp: Date.now(),
          uid: null,
        })
      "
      >Add review</v-btn
    >

    <v-card v-for="review in reviews" :key="review.uid" class="mb-4 pa-4">
      <v-textarea v-model="review.review"></v-textarea>
      <v-text-field v-model="review.name" label="Naam"></v-text-field>

      <v-btn @click="$store.dispatch('deleteReview', review.uid)">Delete</v-btn>
      <v-btn @click="$store.dispatch('updateReview', review)">Save</v-btn>
    </v-card>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState({
      reviews: (state) => state.reviews,
    }),
  },
  mounted() {
    this.$store.dispatch("getReviews");
  },
  data() {
    return {
      headers: [
        { title: "Naam", align: "start", key: "name" },
        { title: "Review", align: "start", key: "review" },
        { title: "Acties", align: "end", key: "actions" },
      ],
      review: {
        review: "",
        name: "",
        rating: 5,
        timestamp: Date.now(),
        uid: null,
      },
      ratings: [1, 2, 3, 4, 5],
    };
  },
  methods: {},
};
</script>
